// Cajón del carrito con el funcionamiento de Sira Montero: cuenta atrás de reserva y protección de envío,
// que sale activada por defecto. Además bloquea el scroll de la página mientras el carrito está abierto.

(function () {
  const CLAVE_FIN = 'lhCarritoFinReserva';
  const CLAVE_SIN_PROTECCION = 'lhCarritoSinProteccion';
  let finEnMemoria = 0;
  let sinProteccionEnMemoria = false;

  function leerFin() {
    try {
      return parseInt(sessionStorage.getItem(CLAVE_FIN), 10) || 0;
    } catch (e) {
      return finEnMemoria;
    }
  }

  function guardarFin(fin) {
    finEnMemoria = fin;
    try {
      sessionStorage.setItem(CLAVE_FIN, String(fin));
    } catch (e) {}
  }

  // La clienta quitó la protección a mano: no se vuelve a poner sola en esta visita
  function proteccionRechazada() {
    try {
      return sessionStorage.getItem(CLAVE_SIN_PROTECCION) === '1';
    } catch (e) {
      return sinProteccionEnMemoria;
    }
  }

  function guardarRechazo(rechazada) {
    sinProteccionEnMemoria = rechazada;
    try {
      if (rechazada) sessionStorage.setItem(CLAVE_SIN_PROTECCION, '1');
      else sessionStorage.removeItem(CLAVE_SIN_PROTECCION);
    } catch (e) {}
  }

  if (!customElements.get('lh-cuenta-atras')) {
    class LhCuentaAtras extends HTMLElement {
      connectedCallback() {
        this.duracion = parseInt(this.dataset.duracion, 10) || 300;
        this.pintar(this.segundosRestantes());
        this.intervalo = setInterval(() => this.pintar(this.segundosRestantes()), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.intervalo);
      }

      segundosRestantes() {
        let fin = leerFin();
        if (!fin) {
          // Como en Sira: marca 05:00 hasta que se abre el carrito por primera vez
          const cajon = this.closest('cart-drawer');
          if (!cajon || !cajon.classList.contains('active')) return this.duracion;
          fin = Date.now() + this.duracion * 1000;
          guardarFin(fin);
        }
        let segundos = Math.ceil((fin - Date.now()) / 1000);
        if (segundos <= 0) {
          // Como en Sira: al llegar a cero vuelve a empezar desde 01:30
          segundos = 90;
          guardarFin(Date.now() + segundos * 1000);
        }
        return segundos;
      }

      pintar(segundos) {
        const minutos = Math.floor(segundos / 60);
        const resto = segundos % 60;
        this.textContent = String(minutos).padStart(2, '0') + ':' + String(resto).padStart(2, '0');
      }
    }
    customElements.define('lh-cuenta-atras', LhCuentaAtras);
  }

  // Repinta el cajón entero (cabecera, cuenta atrás, productos y pie) y la burbuja del carrito
  function pintarCarrito(secciones) {
    const lector = new DOMParser();
    if (secciones && secciones['cart-drawer']) {
      const nuevo = lector.parseFromString(secciones['cart-drawer'], 'text/html').querySelector('.drawer__inner');
      const actual = document.querySelector('#CartDrawer .drawer__inner');
      if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
      const cajon = document.querySelector('cart-drawer');
      if (cajon && nuevo) cajon.classList.toggle('is-empty', !!nuevo.querySelector('.drawer__inner-empty'));
    }
    if (secciones && secciones['cart-icon-bubble']) {
      const burbuja = document.getElementById('cart-icon-bubble');
      const nueva = lector.parseFromString(secciones['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (burbuja && nueva) burbuja.innerHTML = nueva.innerHTML;
    }
  }

  // Las peticiones de la protección van de una en una, para que nunca se crucen
  let cola = Promise.resolve();
  let fallosAutomaticos = 0;

  // Shopify envuelve window.fetch para avisar a los píxeles (Meta incluido) de cada producto que entra en el carrito.
  // La protección se pide con el fetch de un iframe vacío, que Shopify no envuelve: así Meta solo recibe
  // el «Añadir al carrito» de la prenda y no otro aparte por la protección.
  let marcoSinAviso = null;

  function pedirSinAviso(url, opciones) {
    try {
      if (!marcoSinAviso || !marcoSinAviso.isConnected) {
        marcoSinAviso = document.createElement('iframe');
        marcoSinAviso.hidden = true;
        marcoSinAviso.tabIndex = -1;
        marcoSinAviso.setAttribute('aria-hidden', 'true');
        document.body.appendChild(marcoSinAviso);
      }
      return marcoSinAviso.contentWindow.fetch(url, opciones);
    } catch (e) {
      return fetch(url, opciones);
    }
  }

  if (!customElements.get('lh-proteccion')) {
    class LhProteccion extends HTMLElement {
      connectedCallback() {
        this.boton = this.querySelector('.upsell-toggle-btn');
        if (this.boton) {
          this.boton.addEventListener('click', (evento) => {
            evento.preventDefault();
            const activar = this.dataset.selected !== 'true';
            guardarRechazo(!activar);
            this.cambiar(activar);
          });
        }

        // Si en el carrito solo queda la protección, se quita sola
        if (this.dataset.huerfana === 'true') {
          this.cambiar(false);
          return;
        }

        // Activada por defecto: si hay productos y aún no está en el carrito, se añade sola
        const hayProductos = parseInt(this.dataset.cantidad, 10) > 0;
        if (hayProductos && this.dataset.enCarrito !== 'true') {
          if (proteccionRechazada() || fallosAutomaticos >= 2) this.marcar(false);
          else this.cambiar(true, true);
        }
      }

      cambiar(activar, automatico) {
        this.marcar(activar);
        if (this.boton) this.boton.setAttribute('disabled', '');
        cola = cola.then(() => this.enviar(activar, automatico));
        return cola;
      }

      async enviar(activar, automatico) {
        const variante = this.dataset.variante;
        try {
          // /cart/update fija la cantidad exacta (1 o 0): repetir la petición nunca duplica la protección
          const respuesta = await pedirSinAviso(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              updates: { [variante]: activar ? 1 : 0 },
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });
          const carrito = await respuesta.json();
          if (!respuesta.ok || carrito.status) throw new Error(carrito.description || carrito.message || 'Error del carrito');
          const enCarrito = (carrito.items || []).some((item) => String(item.variant_id) === String(variante));
          if (automatico) fallosAutomaticos = enCarrito ? 0 : fallosAutomaticos + 1;
          pintarCarrito(carrito.sections);
        } catch (error) {
          console.error(error);
          if (automatico) fallosAutomaticos += 1;
          if (this.isConnected) {
            this.marcar(!activar);
            if (this.boton) this.boton.removeAttribute('disabled');
          }
        }
      }

      marcar(activo) {
        this.dataset.selected = String(activo);
        if (this.boton) this.boton.setAttribute('aria-checked', String(activo));
      }
    }
    customElements.define('lh-proteccion', LhProteccion);
  }

  // Con el carrito abierto la página de detrás no se mueve. En iPhone no basta con overflow:hidden:
  // hay que fijar el body y devolver el scroll a su sitio al cerrar.
  let scrollGuardado = null;

  function bloquearPagina(bloquear) {
    const raiz = document.documentElement;
    if (bloquear && scrollGuardado === null) {
      scrollGuardado = window.scrollY;
      document.body.style.top = `-${scrollGuardado}px`;
      raiz.classList.add('lh-pagina-bloqueada');
    } else if (!bloquear && scrollGuardado !== null) {
      raiz.classList.remove('lh-pagina-bloqueada');
      document.body.style.top = '';
      const comportamiento = raiz.style.scrollBehavior;
      raiz.style.scrollBehavior = 'auto';
      window.scrollTo(0, scrollGuardado);
      raiz.style.scrollBehavior = comportamiento;
      scrollGuardado = null;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const cajon = document.querySelector('cart-drawer');
    if (cajon) {
      new MutationObserver(() => bloquearPagina(cajon.classList.contains('active'))).observe(cajon, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    // Dawn solo repinta la lista y los totales cuando el carrito cambia desde fuera del cajón;
    // aquí se repinta entero para que la cabecera y la protección no se queden desfasadas.
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (evento) => {
      if (evento && evento.source === 'cart-items') return;
      fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then((respuesta) => respuesta.json())
        .then(pintarCarrito)
        .catch((error) => console.error(error));
    });
  });
})();